import React, { useState } from "react";
import styles from "./styles.module.css";
import ImageComponent from "../ImageComponent";
import clsx from "clsx";

interface Action {
  label: string;
  onClick: () => void;
  style?: React.CSSProperties;
  btnClass?: string;
}

interface BottomSheetModalProps {
  isOpen: boolean;
  modalIcon?: string;
  title?: string;
  content?: React.ReactNode;
  actions?: Action[];
  onClose: () => void;
  modalContentClassName?:string;
  modalBodyClassName?: string;
}

const BottomSheetModal: React.FC<BottomSheetModalProps> = ({
  isOpen,
  modalIcon,
  title,
  content,
  actions = [],
  onClose,
  modalContentClassName,
  modalBodyClassName,
}) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
      onClose();
    }, 300);
  };

  if (!isOpen && !closing) return null;

  return (
    <div className={clsx(styles.modalOverlay)} onClick={handleClose}>
      <div
        className={clsx(styles.modalContent, modalContentClassName ,`${
          closing ? styles.slideDown : styles.slideUp
        }`)}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>
        {title && <div className={clsx(styles.modalHeader)}>
          {modalIcon && <ImageComponent src={modalIcon} alt="icon" className={clsx(styles.modalIcon)} />}
          <h2 className={clsx(styles.modalTitle, "fontWeightBold fontSizeSm20 fontColorBlack")}>{title}</h2>
        </div>}
        <div className={clsx(styles.modalBody, modalBodyClassName)}>{content}</div>
        <div className={styles.buttonContainer}>
          {actions.map((action, index) => (
            <button
              key={index}
              className={`btn ${action.btnClass}`}
              onClick={action.onClick}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomSheetModal;
